var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cd-section",attrs:{"id":"headers"}},[_c('Header1'),_c('Header2'),_c('Header3'),_c('Header4'),_c('Header5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }